var React = require('react');

function Windows (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Windows","opacity":"0.08"},React.createElement("path",{"id":"Windows_2","d":"M141.833 6.1665L68.5732 17.0198V71.2865L141.833 70.6082V6.1665ZM61.7898 77.3915L6.1665 76.7132V122.84L61.1115 130.301L61.7898 77.3915ZM6.1665 25.1598V71.2865H61.1115V17.6982L6.1665 25.1598ZM67.8948 77.3915V130.98L141.833 141.833V78.0698L67.8948 77.3915Z","fill":"white"})));
}

Windows.defaultProps = {"width":"148","height":"90","viewBox":"0 0 148 90","fill":"none"};

module.exports = Windows;

Windows.default = Windows;
